// 费用项
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("expenseItem") || ""
}

const getters = {
  getExpenseItem:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("expenseItem",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("expenseItem")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}